import { memo } from "react";

import { formatters, parsers } from "@fraction/shared";

import KeyValue from "./KeyValue";
import SubmissionSection from "./SubmissionSection";

const LoanInformation = ({ app }: { app: parsers.application.FullApplication }) => (
  <SubmissionSection title="Loan information">
    <KeyValue label="Amount requested" value={formatters.number.getCurrencyFromNumber(app.amountRequested)} />
    {app.useOfFundsChoices && (
      <KeyValue
        label="Use of funds"
        value={app.useOfFundsChoices.map((choice) => formatters.enums.USE_OF_FUNDS_MAP[choice]).join(", ")}
      />
    )}
    {app.termLength && <KeyValue label="Term" value={`${app.termLength} Years`} />}
    {app.useOfFundsDescription && (
      <KeyValue label="Use of funds description" value={app.useOfFundsDescription} />
    )}
  </SubmissionSection>
);

export default memo(LoanInformation);
